module.exports = __webpack_public_path__ + "static/media/dizbuzzicon.c00e59a3.svg";